module.exports = __webpack_public_path__ + "media/LandingPageAssets/tick-d14b205e.svg";